import React from "react";
import { Layout, Menu } from "antd";
import {
  DashboardOutlined,
  LeftOutlined,
  RightOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
// import "./Sidebar.css";
import "./style.css";
import routes from "../Routes/routes";

const { Sider } = Layout;

const menuItems = routes.map((route) => {
  if (route.children) {
    return {
      key: route.path,
      label: route.label,
      children: route.children.map((child) => ({
        key: `${route.path}/${child.path || ""}`,
        label: <Link to={`${route.path}/${child.path}`}>{child.label}</Link>,
      })),
    };
  }

  return {
    key: route.path,
    label: <Link to={route.path}>{route.label}</Link>,
  };
});
const Sidebar = ({ collapsed, setCollapsed, mobileOpen, setMobileOpen }) => {
  const location = useLocation();

  return (
    <>
      {/* 🖥️ Desktop Sidebar */}
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        width={240}
        collapsedWidth={80}
        className="hidden lg:block fixed top-14 left-0 h-[calc(100vh-64px)] custom-sidebar"
      >
        <div className="h-full overflow-y-auto sidebar-scroll">
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            className="sidebar-menu"
          />
        </div>
      </Sider>

      {/* 📱 Mobile Sidebar */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 flex lg:hidden">
          {/* Sidebar */}
          <div className="w-64 bg-gradient-to-b from-cyan-400 to-indigo-900 text-white shadow-lg">
            <div className="h-16 flex items-center justify-center font-bold text-lg">
              Vyona Energy
            </div>

            <Menu
              mode="inline"
              selectedKeys={[location.pathname]}
              items={menuItems}
              className="sidebar-menu"
              onClick={() => setMobileOpen(false)}
            />
          </div>

          {/* Overlay */}
          <div
            className="flex-1 bg-black bg-opacity-40"
            onClick={() => setMobileOpen(false)}
          />
        </div>
      )}
    </>
  );
};

export default Sidebar;
